module.exports = __webpack_public_path__ + "static/media/farmdokDEMockAppleMobileAnimation.b838aecc.gif";